import { TableService } from "service/shared/others/TableService/Table.service";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = TableService;

export const useDefaultObservableTableService = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectTableService extends BehaviorSubject<CurrentType> {}
